
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import OrderModule from "@/store/modules/order";

const orderModule = getModule(OrderModule);

@Component
export default class OrderShipsWithOrders extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get shipsWithOrders(): Array<Object> {
    return orderModule.currentOrderShipsWithOrders;
  }
}
